export default __webpack_public_path__ + "static/media/quality_content.91b64bca.svg";